import { Container, DestroyOptions, Graphics } from "pixi.js";
import { Group } from "tweedle.js";
import { BackGroundComponent } from "../components/backGround/BackGroundComponent";
import { CharacterComponent } from "../components/character/CharacterComponent";
import { LogoComponent } from "../components/logo/LogoComponent";
//import { MeterComponent } from "../components/meter/MeterComponent";
import { ReelFrameComponent } from "../components/reels/ReelFrameComponent";
import { ReelComponent } from "../components/reels/ReelsComponent";
//import { TransitionComponent } from "../components/Transition/TransitionComponent";
import { DisplayComponent } from "../core/displays/DisplayComponent";
import { DisplayComponentFactory } from "../core/displays/DisplayComponentFactory";
import { DisplayObject } from "../core/displays/DisplayObject";
import { IScene } from "../core/interfaces";
import { Manager } from "../core/Manager";
import { Reels } from "../core/reels/Reels";
import { GameConstants } from "../gameClientEvents/GameConstants";
import { BigWin } from "./BigWin";

export abstract class BaseScene extends Container implements IScene {
    assetBundles: string[] = [];
    assets: string[] = [];
    protected game = new Container();
    protected reelFrame = new Container();
    protected background = new Container();
    protected reels: Reels | null = null;
    protected bigWin: BigWin | null = null;
    protected tweenGroup = new Group();
    protected graphics: Graphics;
    protected graphicsOffset: number = 830;

    constructor() {
        super();
    }


    public abstract constructorWithAssets(): Promise<void>;

    protected initBaseLayering() {
        this.initBackground();
        //this.game.addChild(this.reelFrame);
        this.game.label = "game";
        this.addChild(this.background);
        this.addChild(this.game);
    }

    protected addComponent(Comp: any, parent?: Container): any {
        DisplayComponent.register(new DisplayComponentFactory(Comp));
        const component = DisplayComponent.get(Comp);
        component.init();
        //@ts-ignore
        const instance = component.getInstance();
        parent?.addChild(instance);
        return instance;
    }

    protected setupCommonUI() {
        this.addComponent(LogoComponent, this.game);
        this.addComponent(CharacterComponent, this.game);
        //this.addComponent(MeterComponent, this.game);
        //this.addComponent(TransitionComponent, this);
        //this.addComponent(TriumpWinsComponent);
        //this.addComponent(TrailsComponent, this.game);
    }

    //@ts-ignore
    protected initBackground() {
        DisplayComponent.register(new DisplayComponentFactory(BackGroundComponent));
        const backGround = DisplayComponent.get(BackGroundComponent);
        backGround.init();
        this.addChild(backGround.getInstance());
    }

    protected setupReelFrame(skel: string, atlas: string, animate: boolean) {
        DisplayComponent.register(new DisplayComponentFactory(ReelFrameComponent));
        DisplayComponent.get(ReelFrameComponent).setAnim(skel, atlas);
        const reelBack = DisplayComponent.get(ReelFrameComponent).getInstance();
        this.reels.addChildAt(reelBack, 0);
        this.reelFrame.addChild(this.reels);

        this.reelFrame.eventMode = "static";

        this.graphics = new Graphics()
            .rect(0, 0, 1300, 1250)
            .fill(0xDE3249);

        this.graphics.alpha = 0.01;
        this.reels.addChild(this.graphics);
        reelBack.position.set(499, 337);
        //this.reels.pivot.set(this.graphics.width / 2, this.graphicsOffset);
        this.reels.position.set(-493, -193);

        const alpha = animate ? 0 : 1;
        this.reelFrame.alpha = alpha;
    }

    public update(): void {
        this.tweenGroup?.update();
        this.reels?.update();
        this.bigWin?.update();
    }

    public resize(screenWidth: number, screenHeight: number): void {

        const isLandscape = screenWidth > screenHeight;
        const scale = isLandscape ? Math.min(screenWidth / GameConstants.GAME_RES_WIDTH, screenHeight / GameConstants.GAME_RES_HEIGHT) : Math.min(screenWidth / GameConstants.GAME_RES_HEIGHT, screenHeight / GameConstants.GAME_RES_WIDTH);
        console.log("BaseScene resize with scale:", scale);
        this.game.scale.set(scale);
        this.game.position.set(-(GameConstants.BACKGROUND_SIZE * scale - screenWidth) / 2, -(GameConstants.BACKGROUND_SIZE * scale - screenHeight) / 2);
        console.log(this.game.position.x, this.game.position.y);
        // this.reelFrame.scale.set(isLandscape ? 0.8 : 1);
        // this.reelFrame.position.set(isLandscape ? 423 : 9, isLandscape ? 326 : 489);

        // this.reels.position.set(GameConstants.BACKGROUND_SIZE / 2, (GameConstants.BACKGROUND_SIZE - 830));

        [this.game, this].forEach(cont => cont.children.forEach(c => {
            if (c instanceof DisplayObject) c.setPositionResize(Manager.Orientation);
        }));

        // this.bigWin?.scale.set(scale);
        // this.bigWin?.position.set(screenWidth / 2, screenHeight / 2);
    }

    override destroy(options: DestroyOptions) {
        [BackGroundComponent, LogoComponent, CharacterComponent, ReelComponent, ReelFrameComponent]
            .forEach((c: any) => DisplayComponent.unregister(c));
        // this.reels?.destroy();
        // this.reels = null;
        // this.tweenGroup?.removeAll();
        // this.tweenGroup = null;
        super.destroy(options);
    }
}
